import React from 'react';
import { motion } from 'framer-motion';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'Intelligent Processing',
    text: 'Advanced header detection with flexible binary pattern matching for accurate ECU modification.',
  },
  {
    title: 'Secure File Handling',
    text: 'Checksum-aware processing ensures safe and reliable ECU file rebuilding.',
  },
  {
    title: 'Multi-Platform Support',
    text: 'Supports Nissan Hitachi GEN1/GEN2, Denso SH705X, Kia/Hyundai SIM2K and CPEG series.',
  },
  {
    title: 'Professional Diagnostic Console',
    text: 'Real-time status monitoring with structured output for advanced users.',
  },
];

const Features = () => (
  <motion.div
    className="gpt3__features section__padding"
    id="features"
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">Advanced ECU Control Starts Here. Precision Tuning Without Limits.</h1>
      <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
        <p>Launch ECU Processor</p>
      </a>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </motion.div>
);

export default Features;
